var calculateHeightFromContent = function (companyNewsRow) {
    switch (companyNewsRow.length) {
        case 4:
            return 217;
        case 3:
            return 272;
        default:
        case 2:
            return 382;
    }
};
export default calculateHeightFromContent;
